import { MJPromotion } from "../main/promotion3.js";
class Core {
  constructor() {}
  promotion(object) {
    new MJPromotion(object);
  }
}
$(window).on("load", function () {
  // Preload GIF ngay khi page load để tránh delay lần đầu
  var gifSrc =
    "https://cdn-mainsite-aka.vnggames.com/products/gno/landing/2026-gno-4-tuoi/dist/optimized/tf-26-preregister-milestone/images/effect-card.gif";
  var preloadImg = new Image();
  preloadImg.src = gifSrc;

  const dndPromotion = new Core().promotion;

  dndPromotion({
    url: prodTemplate.url,
    debug: prodTemplate.debug,
    directory: prodTemplate.directory,
    items: prodTemplate.items,
    names: prodTemplate.names,
    config: {
      timeWait: 2500,
    },
    animResult: function () {
      // Thêm timestamp để force GIF chạy lại từ đầu mỗi lần click
      var overlayHtml =
        '<div class="gif-overlay">' +
        '  <div class="gif-overlay__bg"></div>' +
        '  <div class="gif-overlay__content">' +
        '    <img src="' +
        gifSrc +
        '" alt="effect" />' +
        "  </div>" +
        "</div>";
      $("body").append(overlayHtml);
      setTimeout(function () {
        $(".gif-overlay").addClass("fade-out");
        setTimeout(function () {
          $(".gif-overlay").remove();
        }, 500);
      }, 2000);
    },
    callback: function () {
      if (typeof prodTemplate.fnPromotion === "function")
        prodTemplate.fnPromotion();
    },
  });
});
